import { render, staticRenderFns } from "./EditShiftDetailDialog.vue?vue&type=template&id=2982fd08"
import script from "./EditShiftDetailDialog.vue?vue&type=script&lang=ts"
export * from "./EditShiftDetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports